import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import landingPageImage from '../../../assets/landingPageTopImage.webp';
import landingPageImage2 from '../../../assets/landingPageCenterImage1.webp';
import landingPageImage3 from '../../../assets/landingPageCenterImage2.webp';
import landingPageImage4 from '../../../assets/landingPageCenterImage3.svg';
import landingPageImage5 from '../../../assets/landingPageCenterImage4.svg';
import landingPageImage6 from '../../../assets/landingPageCenterImage5.svg';
import fullstop from '../../../assets/full-stop.png';
import LandingAskUsPage from "./landing-ask-us-page";
import CountUp from 'react-countup';
import ClientLogoSection from './client-logo-section';

const LandingPage = () => {
    const location = useLocation();
    const sectionRef = useRef(null);
    const [startAnimation, setStartAnimation] = useState(false);

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const source = queryParams.get('source');
        const storedSource = localStorage.getItem('source');
        if (source != null && (!storedSource || source !== storedSource)) {
            localStorage.setItem('source', source);
        }
    }, [location.search]);

    useEffect(() => {
        const callback = (entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    setStartAnimation(true);
                }
            });
        };

        const observer = new IntersectionObserver(callback, { threshold: 0.5 });
        if (sectionRef.current) {
            observer.observe(sectionRef.current);
        }

        return () => observer.disconnect();
    }, []);

    const formatNumber = (value) => {
        if (value >= 1000000000) return (value / 1000000000).toFixed(value % 1000000000 === 0 ? 0 : 1) + 'B';
        if (value >= 1000000) return (value / 1000000).toFixed(value % 1000000 === 0 ? 0 : 1) + 'M';
        if (value >= 1000) return (value / 1000).toFixed(value % 1000 === 0 ? 0 : 1) + 'K';
        return value;
    };

    return (
        <>
            {/* Landing Page Section 1 */}
            <div className='bg-[hsl(264,50%,96%)]'>
                <div className="  mx-16 xl:m-auto max-w-[93rem] max-xs:mx-0">
                    <div className="flex items-center pt-32 pb-32 gap-[163px] xl:gap-[143px] max-xs:flex-col-reverse max-xs:gap-[55px] max-xs:py-8">
                        <div className="flex-1 w-[517px] max-xs:w-auto max-xs:mx-8 max-xs:text-center">
                            <div className="font-semibold text-30 font-sans xl:text-40 leading-[40.85px] xl:leading-[54.47px]">
                                Profit from <span className="title-color text-primary-200 font-bold">Social Media</span>
                            </div>
                            <div className="text-16 font-normal font-sans xl:text-20 xl:font-light leading-[30px] xl:leading-[40px] pt-5 xl:pt-10 pb-12 xl:pb-14">
                                A passionate army of mid-tier creators works diligently to ensure
                                your product or service reaches and engages with most prospects.
                                Target a defined market or several individual ones. Make the most of
                                your media spend.
                            </div>
                            <div className="bg-primary-500 rounded-full w-[201px]  h-[40px] xl:w-[209px] xl:h-[48px] flex justify-center items-center max-xs:w-auto">
                                <Link className="text-14 font-bold text-white no-underline font-sans leading-[19.07px] "
                                    to="/signup/for-businesses"
                                >
                                    Launch Free Campaign <span >&gt;</span>
                                </Link>
                            </div>
                        </div>
                        <div className="flex max-xs:justify-center">
                            <img className="w-[472px] h-[476px] xl:w-[744px] xl:h-[711px] max-xs:w-[290px] max-xs:h-[300px]" src={landingPageImage} alt="Landing Page" />
                        </div>
                    </div>
                </div>
            </div>

            {/* Landing Page New section 2*/}
            <div className="pt-20 max-xs:mx-8 mx-16 xl:m-auto max-w-[93rem] max-xs:pt-8 pb-6">
                <div className="font-sans text-center font-normal text-16 max-xs:text-[0.8rem] xl:text-20  pb-12 leading-[21.79px] xl:leading-[27.24px] xl:h-[33px]">
                    Team up with the marketing teams of well-loved brands via  <span className="font-normal text-20 xl:text-24 xl:font-semibold text-[#F482C0] max-xs:text-[0.8rem]">Oye Creators</span>.
                </div>
                <ClientLogoSection />
            </div>

            {/* Landing Page Section 3 */}
            <div className='bg-[#F9B4DA1A] flex justify-center'>
                <div ref={sectionRef} className="   mx-16 xl:m-auto max-w-[93rem] flex flex-col py-16 xl:py-20 max-xs:py-8 items-center  max-xs:w-auto max-xs:mx-[30px] max-xs:h-auto max-xs:gap-8">
                    <div className="h-[81px] max-xs:h-auto xl:h-[91px] gap-16  xl:gap-32 max-xs:gap-8 grid grid-cols-[2fr_2fr_2fr_2fr] max-xs:grid-cols-2 justify-center items-center text-center pb-12 xl:pb-20 max-xs:pb-0">
                        <div>
                            <div className="font-sans font-semibold text-[32px] xl:text-40 max-xs:text-16 leading-[43.58px] xl:leading-[54.47px] max-xs:leading-none max-sm:leading-none ">
                                {startAnimation && (
                                    <span>
                                        <CountUp end={40} duration={3} formattingFn={formatNumber} /> Years
                                    </span>
                                )}
                            </div>
                            <div className="font-sans font-normal text-20 whitespace-nowrap max-xs:text-[0.65rem]">Experience in the leadership team</div>
                        </div>
                        <div>
                            <div className="font-sans font-semibold text-[32px] xl:text-40 max-xs:text-16 leading-[43.58px] xl:leading-[54.47px]  max-xs:leading-none max-sm:leading-none ">
                                {startAnimation && (
                                    <CountUp end={300000} duration={3} formattingFn={formatNumber} />
                                )}
                            </div>
                            <div className="font-sans font-normal text-20 whitespace-nowrap max-xs:text-[0.65rem]">Accounts Reached</div>
                        </div>
                        <div>
                            <div className="font-sans font-semibold text-[32px] xl:text-40 max-xs:text-16 leading-[43.58px] xl:leading-[54.47px]  max-xs:leading-none max-sm:leading-none ">
                                {startAnimation && (
                                    <CountUp end={115000} duration={3} formattingFn={formatNumber} />
                                )}
                            </div>
                            <div className="font-sans font-normal text-20 whitespace-nowrap  max-xs:text-[0.65rem]">Avg. Accounts Reached </div>
                        </div>

                        <div>
                            <div className="font-sans font-semibold text-[32px] xl:text-40 max-xs:text-16 leading-[43.58px] xl:leading-[54.47px]  max-xs:leading-none max-sm:leading-none ">
                                {startAnimation && (
                                    <CountUp end={90000} duration={3} formattingFn={formatNumber} />
                                )}
                            </div>
                            <div className="font-sans font-normal text-20 whitespace-nowrap max-xs:text-[0.65rem]">Creators Across India</div>
                        </div>
                    </div>
                    <div className="flex justify-center items-center ">
                        <div className="w-[670px] h-[81px] xl:h-[91px] gap-16 xl:gap-32 grid grid-cols-[2fr_2fr_2fr] max-xs:grid-cols-3 max-xs:gap-2 justify-center items-center text-center max-xs:w-auto max-xs:h-auto">
                            <div>
                                <div className="font-sans font-semibold text-[32px] xl:text-40 max-xs:text-16 leading-[43.58px] xl:leading-[54.47px]  max-xs:leading-none max-sm:leading-none ">
                                    {startAnimation && (
                                        <CountUp end={2000} duration={2} formattingFn={(value) => `${new Intl.NumberFormat().format(value)}+`} />
                                    )}
                                </div>
                                <div className="font-sans font-normal text-20 whitespace-nowrap max-xs:text-[0.65rem]">Content Created</div>
                            </div>
                            <div>
                                <div className="font-sans font-semibold text-[32px] xl:text-40 max-xs:text-16 leading-[43.58px] xl:leading-[54.47px]  max-xs:leading-none max-sm:leading-none ">
                                    {startAnimation && (
                                        <CountUp end={900000000} duration={3.5} formattingFn={formatNumber} />
                                    )}
                                </div>
                                <div className="font-sans font-normal text-20 whitespace-nowrap max-xs:text-[0.65rem]">Content Views</div>
                            </div>
                            <div>
                                <div className="font-sans font-semibold text-[32px] xl:text-40 max-xs:text-16 leading-[43.58px] xl:leading-[54.47px]  max-xs:leading-none max-sm:leading-none ">
                                    {startAnimation && (
                                        <CountUp end={25000} duration={2.5} formattingFn={(value) => {
                                            const formattedValue = new Intl.NumberFormat().format(value);
                                            return formattedValue.replace(/^(\d{2})(\d{3})/, '$1,$2') + '+';
                                        }} />
                                    )}
                                </div>
                                <div className="font-sans font-normal text-20 whitespace-nowrap max-xs:text-[0.65rem]">Hours of watch time</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Landing Page Section 4 */}
            <div className="flex gap-[100px] py-20  mx-16 xl:m-auto max-w-[93rem] justify-center xl:gap-[107.26px] max-xs:mx-0 max-xs:flex-col max-xs:gap-10 max-xs:pt-0 max-xs:pb-20 max-xs:items-center ">
                <div className="flex justify-center items-center ">
                    <img className="w-[450px] h-[384px] xl:w-[608.74px] xl:h-[436px] max-xs:w-[290px] max-xs:h-[300px]" src={landingPageImage2} alt='' />
                </div>
                <div className="max-xs:w-auto max-xs:mx-8">
                    <div className="font-sans font-semibold text-30 pb-14 xl:text-40 leading-[40.85px] xl:leading-[54.47px] max-xs:text-center">Not just reels but wheels of <span className="text-[#F482C0] font-bold">Reach</span> and <span className="text-[#F482C0] font-bold">Engagement</span></div>
                    <div className="flex flex-col gap-4  pb-14 " >
                        <div className="flex">
                            <div>
                                <img src={fullstop} alt="fullstop img" className='w-[25px] pt-[2px]' />
                            </div>
                            <div className="font-sans font-normal text-16 xl:text-20 leading-[21.79px] xl:leading-[27.24px]">
                                Social media accounts or creators with loyal audiences.
                            </div>
                        </div>

                        <div className="flex">
                            <div>
                                <img src={fullstop} alt="fullstop img" className='w-[25px] pt-[2px]' />
                            </div>
                            <div className="font-sans font-normal text-16 xl:text-20 leading-[21.79px] xl:leading-[27.24px]">
                                Consumers are 82% more likely to buy a product a micro-creator recommends.
                            </div>
                        </div>
                        <div className="flex">
                            <div>
                                <img src={fullstop} alt="fullstop img" className='w-[25px] pt-[2px]' />
                            </div>
                            <div className="font-sans font-normal text-16 xl:text-20 leading-[21.79px] xl:leading-[27.24px]">
                                Nano creators have the highest engagement rate b/w any influencer type at 8.8%.
                            </div>
                        </div>
                    </div>
                    <div className="bg-primary-500 rounded-full h-[40px] xl:h-[48px] w-[182px] xl:w-[190px] max-xs:w-auto flex justify-center items-center">
                        <Link className="font-sans text-14 font-bold no-underline text-white leading-[19.07px] " to="/signup/for-businesses">Find Creators Now <span className="arrow">&gt;</span></Link>
                    </div>
                </div>
            </div>

            {/* Landing Page Section 5 */}
            <div className='bg-[#AC8EE11A]'>
                <div className="flex gap-[100px] py-10 xl:py-12 mx-16 xl:m-auto max-w-[93rem] justify-between xl:gap-[164px] max-xs:flex-col-reverse max-xs:items-center max-xs:mx-0 max-xs:gap-[45px]">
                    <div className="w-[577px] max-xs:w-auto max-xs:mx-8">
                        <div className="font-sans font-semibold text-30 pb-10 xl:text-40 xl:leading-[54.47px] max-xs:text-center">Make <span className="text-[#F482C0] font-bold">Reach, Resonance </span> and <span className="text-[#F482C0] font-bold">ROI</span></div>
                        <div className="pb-10 font-sans font-semibold text-20">Quick and In Limited Budgets</div>
                        <div className="pb-10 flex flex-col gap-4">
                            <div className="flex">
                                <div>
                                    <img src={fullstop} alt="fullstop img" className='w-[25px] pt-[2px]' />
                                </div>
                                <div className="font-sans font-normal text-16 xl:text-20">
                                    Launch in no time.
                                </div>
                            </div>
                            <div className="flex">
                                <div>
                                    <img src={fullstop} alt="fullstop img" className='w-[25px] pt-[2px]' />
                                </div>
                                <div className="font-sans font-normal text-16 xl:text-20">
                                    Leverage a diverse network of mid-tier creators.
                                </div>
                            </div>
                            <div className="flex">
                                <div>
                                    <img src={fullstop} alt="fullstop img" className='w-[25px] pt-[2px]' />
                                </div>
                                <div className="font-sans font-normal text-16 xl:text-20">
                                    Grow authenticity and personal relevance.
                                </div>
                            </div>
                            <div className="flex">
                                <div>
                                    <img src={fullstop} alt="fullstop img" className='w-[25px] pt-[2px]' />
                                </div>
                                <div className="font-sans font-normal text-16 xl:text-20 whitespace-nowrap max-xs:whitespace-normal">
                                    Drive genuine messaging, cutting through information overload.
                                </div>
                            </div>
                            <div className="flex">
                                <div>
                                    <img src={fullstop} alt="fullstop img" className='w-[25px] pt-[2px]' />
                                </div>
                                <div className="font-sans font-normal text-16 xl:text-20">
                                    Build engagement for personally shared content.
                                </div>
                            </div>
                        </div>
                        <div className='bg-primary-500 rounded-full w-[223px] max-xs:w-auto h-[40px] xl:h-[48px] xl:w-[231px] flex justify-center items-center'>
                            <Link className="font-bold text-16 text-white no-underline font-sans leading-[21.79px]" to="/signup/for-businesses">Make Your Campaign <span className="arrow">&gt;</span></Link>
                        </div>
                    </div>
                    <div className="flex justify-end items-end ">
                        <img className="w-[467px] h-[423] xl:w-[635px] xl:h-[577px] max-xs:w-[290px] max-xs:h-[300px]" src={landingPageImage3} alt='' />
                    </div>
                </div>
            </div>

            {/* Landing Page Section 6 */}
            <div className="mx-16 xl:m-auto max-w-[93rem] pt-20 pb-20 max-xs:px-0 max-xs:py-8 max-xs:mx-8">
                <div className="flex justify-center pb-12 xl:pb-20 max-xs:mx-8">
                    <h2 className="font-sans font-semibold text-30 m-0 xl:font-bold xl:text-40 max-xs:text-[1rem]"><span className="text-[#F482C0]"> Technology</span> Enabled and Support<br></br></h2>
                </div>
                <div className="flex justify-between xl:gap-[163px] max-xs:flex-col max-xs:items-center">
                    <div className="w-[384.33px] max-xs:w-auto">
                        <div className="flex justify-center">
                            <img className='w-[120px] h-[120px] xl:w-[180px] xl:h-[180px]' src={landingPageImage4} alt='' />
                        </div>
                        <div className="pt-9 ">
                            <div className="font-sans font-semibold text-20 text-center xl:text-24 max-xs:text-[1rem]">POWER AI, DATA AND ANALYTICS</div>
                        </div>
                        <div className="font-sans font-normal text-16 text-center xl:text-20 pt-9 max-xs:text-[14px]">
                            We track and analyze content performance for you through intelligent analysis using our 7-day matrix method, ensuring continual improvement and success.
                        </div >
                    </div>
                    <div className="w-[384.33px] max-xs:w-auto max-xs:pt-8">
                        <div className="flex justify-center">
                            <img className='w-[120px] h-[120px] xl:w-[180px] xl:h-[180px]' src={landingPageImage5} alt='' />
                        </div>
                        <div className="font-sans font-semibold text-20 pt-9 text-center xl:text-24 max-xs:text-[1rem]">MODEST INVESTMENTS, MORE THAN MODERATE RETURNS</div>
                        <div className="font-sans font-normal text-16 text-center xl:text-20 pt-9 max-xs:text-[14px]">
                            Introducer plan and Adopter plan are<br></br> plans for Investments.
                        </div>
                    </div>
                    <div className="w-[384.33px] max-xs:w-auto max-xs:pt-8">
                        <div className="flex justify-center">
                            <img className='w-[120px] h-[120px] xl:w-[180px] xl:h-[180px]' src={landingPageImage6} alt='' />
                        </div>
                        <div className="font-sans font-semibold text-20 pt-9 text-center xl:text-24 max-xs:text-[1rem]">PROFIT FROM BEING A PART<br /> OF SOCIAL MEDIA</div>
                        <div className="font-sans font-normal text-16 text-center xl:text-20 pt-9 max-xs:text-[14px]">
                            Inviting nano and micro-influencers to join our army and learn with us. Earn money from us. Grow with us.
                        </div>
                    </div>
                </div>
            </div>
            <div className="pb-12 max-xs:w-auto max-xs:mx-8">
                <p className="font-sans font-semibold text-16 text-center m-0 xl:text-20">
                    Great clients bring products and a flock of mid-tire creators build reach. We are happy to mediate.
                </p>
            </div>
            <div className="flex justify-center">
                <div className="flex justify-center  items-center bg-primary-500  rounded-full w-[249px] h-[40px] xl:w-[257px] xl:h-[48px]">
                    <Link className="font-sans text-14 font-bold text-white no-underline leading-[19.07px]" to="/signup/for-businesses">Register as Enterprise Client <span className="arrow">&gt;</span></Link>
                </div>
            </div>
            {/* Landing Ask Us Page Section */}
            <LandingAskUsPage />
        </>
    );
}

export default LandingPage;
